module.exports = __webpack_public_path__ + "img/emoji_50.144f203f.png";